import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import "./paymentSuccess.css";
import step1 from "assets/choosePlan-image/icon_step1_choose_plan_active.svg";
import step2 from "assets/choosePlan-image/icon_step2_choose_plan_active.svg";
import step3 from "assets/choosePlan-image/icon_step3_choose_plan_active.svg";
import pay_suc_gif from "assets/payment/payment_success.gif";
import { useLocation } from "react-router-dom";
import Meta from "utils/meta";
import PricingHeader from "../../Component/PricingHeader/pricingHeader";

const PaymentSuccess = () => {
  const location = useLocation();
  const [copiedId, setCopiedId] = useState(null);
  const { razorpay_payment_id, razorpay_subscription_id } = location.state || {};

  const handleCopy = (text, type) => {
    navigator.clipboard.writeText(text.trim()).then(() => {
      setCopiedId(type);
    });
  };

  setTimeout(() => setCopiedId(null), 3000);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (<div className="container">
      <Meta title="Payment Success | The Realtor Desk" description="" />
      <div className="paymentSuccess-container">
        <PricingHeader
            title="Register your account with us, it's free"
            subTitle=""
            step1={step1}
            step2={step2}
            step3={step3}
            isLine1Active={true}
            isLine2Active={true}
        />
        <div className="paymentSuccess-box">
          <div className="paymentSuccess-gif">
            <img src={pay_suc_gif} alt="Payment Success Animation" />
            <h2>Payment Successful</h2>
          </div>
          <p className="plan-purchase">
            Thank you for subscribing! Please check your inbox for the
            subscription details. <br />A login link and further information
            will be sent to your email. If you do not receive the email, please
            contact us.
          </p>
          <div className="razorpay-payment-details">
            <div className="razorpay-payment-row">
              <span className="razorpay-payment-label">
                Razorpay Payment ID:
              </span>
              <span className="razorpay-payment-value">
                {razorpay_payment_id}
              </span>
              {razorpay_payment_id && (
                <button
                  onClick={() => handleCopy(razorpay_payment_id, "payment")}
                  className={`copy-button ${
                    copiedId === "payment" ? "copied" : ""
                  }`}
                >
                  <FontAwesomeIcon icon={faCopy} />
                </button>
              )}
            </div>
            <div className="razorpay-payment-row">
              <span className="razorpay-payment-label">
                Razorpay Subscription ID:
              </span>
              <span className="razorpay-payment-value">
                {razorpay_subscription_id}
              </span>
              {razorpay_subscription_id && (
                <button
                  onClick={() =>
                    handleCopy(razorpay_subscription_id, "subscription")
                  }
                  className={`copy-button ${
                    copiedId === "subscription" ? "copied" : ""
                  }`}
                >
                  <FontAwesomeIcon icon={faCopy} />
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSuccess;
